module.exports = new __parcel__URL__("65210_h.2976ae3f.jpg").toString();